import React from 'react';
import {ControlButton, TscButtonType, Glyphs, TscThemeNames} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from '../../constants/cssConstants';
import {IComment} from '../../model/commentModel';
import {useTranslation} from 'react-i18next';
import {CommentFooterWrapper} from '../util/StyledElements';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {themeStore} from '../../context/themeProvider';

export const EditingCommentFooterBase: React.FC<IEditingCommentFooterProps & IStateMappedProps> = ({isCommentOwner, comment, onSubmit, editedText, setShowDeleteAlertModal, deleteAnnotationOnSave, isReply, onCancel, theme}) => {
   const {t} = useTranslation();

   return (
      <CommentFooterWrapper isCommentOwner={isCommentOwner} isReply={isReply} isEditing={true}>
         <ControlButton
            onClick={() => setShowDeleteAlertModal(true)}
            title={t('conversations.deleteComment')}
            glyph={<Glyphs.Delete16x16 />}
            testId="delete-comment-button"
            buttonType={TscButtonType.destructive}
            disabled={comment.isDeleted}
         />
         <ControlButton
            onClick={onCancel}
            title={t('conversations.cancelEdit')}
            label={t('general.cancel')}
            testId="cancel-editing-button"
            buttonType={TscButtonType.tertiary}
            themeName={theme}
            width={cssConstants.smallButtonWidth}
         />
         <ControlButton
            onClick={() => onSubmit()}
            title={t('conversations.saveEdit')}
            label={t('general.save')}
            testId="save-edit-button"
            buttonType={TscButtonType.primary}
            themeName={theme}
            width={cssConstants.smallButtonWidth}
            disabled={comment.text === editedText && !deleteAnnotationOnSave}
         />
      </CommentFooterWrapper>
   );
};

export interface IEditingCommentFooterProps {
   comment: IComment;
   editedText: string;
   deleteAnnotationOnSave: boolean;
   isReply: boolean;
   isCommentOwner: boolean;
   setShowDeleteAlertModal(showDeleteAlertModal: boolean): void;
   onSubmit(): void;
   onCancel(): void;
}

export interface IStateMappedProps {
   theme: TscThemeNames;
}

const mapStatesToProps = (
   {comment, editedText, deleteAnnotationOnSave, isReply, isCommentOwner, setShowDeleteAlertModal, onSubmit, onCancel}: IEditingCommentFooterProps,
   {theme}: Partial<IStateMappedProps>
): IStateMappedProps & IEditingCommentFooterProps => ({comment, editedText, deleteAnnotationOnSave, isReply, isCommentOwner, setShowDeleteAlertModal, onSubmit, onCancel, theme});

export default withMemoizedContexts(mapStatesToProps, themeStore)(EditingCommentFooterBase);
